import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
  Message,
} from "@aws-amplify/ui-react";
import { useContext } from "react";
import { GlobalContext } from "../context/global";
import { INutritionData } from "../interfaces";
import { APadded, NextBackButtonHolder } from "../components/layout";
import { AH2 } from "../components/text";
import { Products } from "../components/products";
import { useNavigate } from "react-router";
import { CalorieBar } from "../components/calorieBar"
import styled from "styled-components";
import { Navigate } from "react-router-dom";

const Spacer = styled(View)`
margin-top:7px;
`

const TextSmall = styled(Text)`
  font-size:small;
`

const TopTextHolder = styled(View)`
  margin-top:10px;
`

const foo = (x : number) => {}

export const ViewEventBasketSalt = () => {
    const navigate = useNavigate();
    const {nutritionData, addSaltCapsule, addSaltChew, basket} = useContext(GlobalContext);

    const haveBasket = (nutritionData as any).hasLoaded
    if (!haveBasket) {
      return <Navigate to="/" />
    }
    
    const nutrition = nutritionData as INutritionData;
    const saltMgEneryProducts = (basket.bars * (nutrition.products.bar?.saltContentMg || 0)) + (basket.drinks * (nutrition.products.drink?.saltContentMg || 0)) + (basket.gels * (nutrition.products.gel?.saltContentMg || 0))
    const saltMgSaltProducts = (basket.saltChew * (nutrition.products.saltChew?.saltContentMg || 0)) + (basket.saltCapsule * (nutrition.products.saltCapsule?.saltContentMg || 0)) ;
    const saltMgInBasket = saltMgEneryProducts + saltMgSaltProducts;

    const goToNext = () => {
      navigate("/event/new/1/basket/water")
    }

    const goBack = () => {
      navigate("/event/new/1/basket/calories")
    }

    const productData = [{
      numInBasket: basket.saltCapsule,
      info: nutrition.products.saltCapsule,
      addFunc: addSaltCapsule,
    },{
      numInBasket: basket.saltChew,
      info: nutrition.products.saltChew,
      addFunc: addSaltChew,
    }]

    let tipText = "You need to add some more salt"
    let messageTheme = "info"
    if (saltMgInBasket >= 0.6 * nutrition.depletion.saltMg) {
      tipText = "You are out of the depletion zone"
      messageTheme = "success"
    }


    return <APadded>
      <AH2>Choose your mix of salts.</AH2>
      <Spacer/>
      <Message
        variation="filled"
        colorTheme={messageTheme as any}
        isDismissible={false}
        heading="">
        Use the buttons below to add items to your salt mix<br/>
        <b>{tipText}</b>
        </Message>
      <TopTextHolder>
      <View>
        <Text>Salt (Na<sup>+</sup>) required: {nutrition.depletion.saltMg}mg</Text>
      </View>
      <View>
        <Text>Salt in your pack: {saltMgInBasket}mg</Text>
        <TextSmall>(salt from your fuel products is already included in this amount)</TextSmall>
      </View>
      </TopTextHolder>
      <View>
        <CalorieBar units={"mg"} maxCalories={nutrition.depletion.saltMg} currentCalories={saltMgInBasket} />
      </View>
      <Products 
        products={productData}
       />
       <NextBackButtonHolder>
       <Button onClick={goBack}>
              ‹ Back 
            </Button>
            &nbsp;
      <Button onClick={goToNext}>
                Next ›
            </Button>
        </NextBackButtonHolder>
    </APadded>
}